import React from "react";
import styles from "./CircularProgress.module.scss";

const CircularProgress = ({ value }) => {
  const strokeWidth = 8; // Increase thickness
  const radius = 12 - strokeWidth / 2; // Adjust radius to prevent cropping
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  // Color logic (Green if < 80%, Red if ≥ 80%)
  const color = value >= 80 ? "#e74c3c" : "#27ae60";

  return (
    <div className={styles.progressContainer}>
      <svg width="30" height="30" viewBox="0 0 40 40">
        <circle
          className={styles.bg}
          cx="20"
          cy="20"
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className={styles.progress}
          cx="20"
          cy="20"
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <span className={styles.percentage}>{value ? Math.floor(value): '-'}%</span>
    </div>
  );
};

export default CircularProgress;
